import { ConfigContaProyectosService } from 'src/app/services/ConfigContaProyectos.service';
import { StorageService } from 'src/app/services/storage.service';
import { TableFunctionService } from 'src/app/services/table-function.service';
import { ModalBusquedaPlanCuentasComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-plan-cuentas/modal-busqueda-plan-cuentas.component';
import { SubCentroCostosService } from 'src/app/services/sub-centro-costos.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ModalBusquedaProyectosComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proyectos/modal-busqueda-proyectos.component';
import { ModalBusquedaSubCentroComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-sub-centro/modal-busqueda-sub-centro.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistroComprasService } from 'src/app/services/registro-compras.service';
import { obtenerFechaActual, basicAlert, obtenerFechaSeleccionada, alertaConfirmacionHTML, timerOut, obtenerDias, validarCodigoExistentesRC, filtrarCoincidenciaArrayCuenta, alertaRouter, alertaConfirmacion, filtrarCoincidenciaArrayDocume } from 'src/app/shared/utils';
import { Location } from '@angular/common';
import { PlanCuentaService } from 'src/app/services/plancuenta.service';
import { NgbActiveModal, NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';
import { DataService } from 'src/app/services/dataService.service';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ModalBusquedaInterlocutorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { ProveedorService } from 'src/app/services/proveedor.service'
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component';
import { DocumentosCobranzaService } from 'src/app/services/documentos-cobranza.service'
import { ModalBusquedaTdocumentosComponent } from '../busqueda/modal-busqueda-tdocumentos/modal-busqueda-tdocumentos.component';
import { CuentaPorCobrarService } from 'src/app/services/cuentaporcobrar.service'
import { TDocumeRestService } from 'src/app/services/TDocume.service'
import { BuscarService } from 'src/app/services/buscar.service';
import { PlanillaLiquidacionService } from 'src/app/services/planilla-liquidacion.service';

@Component({
  selector: 'app-modal-detalles-cuentas',
  templateUrl: './modal-detalles-cuentas.component.html',
  styleUrls: ['./modal-detalles-cuentas.component.css']
})
export class ModalDetallesCuentasComponent implements OnInit {
  @Input() detalles: any[] = [];
  @Input() tipo;

  constructor(    
    private tableFunction: TableFunctionService,
    private proyectoService: ConfigContaProyectosService,
    private SubCentroCostosService: SubCentroCostosService,
    private spinnerService: SpinnerService,
    private modalService: NgbModal,
    private _route: ActivatedRoute,
    private _location: Location,
    private router: Router,
    private cuentasService: PlanCuentaService,
    private registroComprasService: RegistroComprasService,
    private storageService: StorageService,
    private modalServicemodal: NgbActiveModal,
    private decimalPipe: DecimalPipe,
    private DataService : DataService,
    private interlocutorService: InterlocutorService,
    private proveedorService: ProveedorService,
    private documentosCobranzaService: DocumentosCobranzaService,
    private CuentaPorCobrarService: CuentaPorCobrarService,
    private TDocumeRestService: TDocumeRestService,
    private _buscarService: BuscarService,
    private PlanillaLiquidacionService : PlanillaLiquidacionService
    ){}

  ngOnInit(): void {
  }

  cancelar() {
    this.modalServicemodal.dismiss('canceling');
  }

  imprimir(data:any){
    console.log(data)
   let datos :any[] = []
   datos = data.planilla.split("-");
   if(datos[0]=="16" || datos[0]=="06" || datos[0]=="68"  || datos[0]=="12"  || datos[0]=="21"  || datos[0]=="25"  || datos[0]=="26"  || datos[0]=="31"  || datos[0]=="35" || datos[0]=="36"  || datos[0]=="37" || datos[0]=="38"  || datos[0]=="64" || datos[0]=="65" || datos[0]=="66" || datos[0]=="67"  || datos[0]=="69"){
    this.spinnerService.activarLoading(true);
    this.PlanillaLiquidacionService.imprimir(data.planilla).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });
   }else{
    this.spinnerService.activarLoading(true);
    this.PlanillaLiquidacionService.imprimirPagar(data.planilla).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });
   }
   // return;
   
  }


  cuentaColorTemp
  onClick(data: any): void {
    this.cuentaColorTemp = data;
  }

}
